import { Link } from "react-router-dom";
import { catPath, formatDate, mediaUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const ArticleCard = ({ article: a, testId }) => {
  const { catName } = useSettings();
  return (
    <article data-testid={testId} className="news-card flex flex-col h-full fade-up">
      <Link to={`/article/${a.slug}`} className="block relative aspect-[16/10] overflow-hidden bg-zinc-200">
        {a.image_url && <img src={mediaUrl(a.image_url)} alt={a.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />}
      </Link>
      <div className="relative">
        <Link to={catPath(a.category)} className="badge-cat hover:bg-red-800 absolute left-3 -top-7 z-10">{catName(a.category)}</Link>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-[15px] leading-snug line-clamp-2 hover:text-red-600 transition-colors">
          <Link to={`/article/${a.slug}`}>{a.title}</Link>
        </h3>
        {a.excerpt && <p className="text-sm text-zinc-600 mt-2 line-clamp-2">{a.excerpt}</p>}
        <div className="meta mt-auto pt-3">
          <span>{formatDate(a.published_at)}</span><span>/</span><span>{a.author}</span>
        </div>
      </div>
    </article>
  );
};

export const CompactItem = ({ article: a, testId }) => {
  const { catName } = useSettings();
  return (
    <Link to={`/article/${a.slug}`} data-testid={testId} className="flex gap-3 group">
      <div className="w-24 h-20 shrink-0 overflow-hidden bg-zinc-200">
        {a.image_url && <img src={mediaUrl(a.image_url)} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />}
      </div>
      <div className="min-w-0">
        <span className="badge-cat">{catName(a.category)}</span>
        <h4 className="font-heading font-bold text-sm leading-snug mt-1 line-clamp-2 group-hover:text-red-600 transition-colors">{a.title}</h4>
        <div className="meta mt-1">{formatDate(a.published_at)}</div>
      </div>
    </Link>
  );
};
